import { BankStatementsConstants } from 'constants/bankStatementsConstants';
import { createAction } from 'redux-actions';

export const setDataVersionAction = createAction(BankStatementsConstants.SET_DATA_VERSION);
export const getStatementsAction = createAction(BankStatementsConstants.GET_STATEMENTS);
export const processStatementAction = createAction(BankStatementsConstants.PROCESS_STATEMENT);
export const getStatementAction = createAction(BankStatementsConstants.GET_STATEMENT);
export const getPDFFileAction = createAction(BankStatementsConstants.GET_PDF_FILE);
export const getConfidenceThresholdAction = createAction(BankStatementsConstants.GET_CONFIDENCE_THRESHOLD);
export const deleteStatementAction = createAction(BankStatementsConstants.DELETE_STATEMENT);
export const restoreStatementAction = createAction(BankStatementsConstants.RESTORE_STATEMENT);
export const updateTransationAction = createAction(BankStatementsConstants.UPDATE_TRANSACTION);
export const updateAccountAction = createAction(BankStatementsConstants.UPDATE_ACCOUNT);
export const deleteTransactionAction = createAction(BankStatementsConstants.DELETE_TRANSACTION);
export const addTransactionAction = createAction(BankStatementsConstants.ADD_TRANSACTION);
export const updateStatementAction = createAction(BankStatementsConstants.UPDATE_STATEMENT);
export const reconcileStatementAccountAction = createAction(BankStatementsConstants.RECONCILE_STATEMENT_ACCOUNT);
